const BaseLazyComponents = {
    SideBarMenu: () => import('../components/organisms/SideBarMenu/SideBarMenu'),
};

const EpiServerBlocks = {
    EpiBlockLoader: () => import('../../episerver/components/base/EpiBlockLoader'),
    CustomerServiceBlock: () => import('../components/organisms/CustomerServiceBlock'),
};

const EcommerceLazyComponents = {
    ImageTextPropertyBlock: () =>
        import('../components/organisms/ImageTextPropertyBlock/ImageTextPropertyBlock'),
    SingleImageTextBlock: () =>
        import('../components/organisms/SingleImageTextBlock/SingleImageTextBlock'),
    DoubleImageTextBlock: () =>
        import('../components/organisms/DoubleImageTextBlock/DoubleImageTextBlock'),
    TripleImageTextBlock: () =>
        import('../components/organisms/TripleImageTextBlock/TripleImageTextBlock'),
    RecipeItemPagePartial: () =>
        import('../../recipe/components/RecipeItemPagePartial/RecipeItemPagePartial'),
};

export const mountableReactComponents = {
    ...BaseLazyComponents,
    ...EcommerceLazyComponents,
    ...EpiServerBlocks,
};

export type MountableReactComponentsType = keyof typeof mountableReactComponents;

export const isMountableReactComponent = (
    cmpName: string,
): cmpName is MountableReactComponentsType => {
    return Object.keys(mountableReactComponents).includes(cmpName);
};
